// eslint-disable-next-line no-unused-vars
import React from 'react';
import { Button } from '@carbon/react';
import { useTranslation } from 'react-i18next';
import { func, node } from 'prop-types';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { X } from 'lucide-react';

const StyledContainer = styled.div`
  background-color: ${ props => props.theme.filters.colors.activeFiltersBg };
  border: 1px solid ${ props => props.theme.products.colors.border };
  font-size: 0.875rem;
  color: ${ props => props.theme.colors.darkGray };
  margin: 10px 0 20px;

  span {
    font-weight: 600;
  }

  .clearAll {
    justify-content: space-between;
    width: 100%;
    padding: 10px;
    min-height: 10px;
    font-size: inherit;
    color: inherit;
    background-color: ${ props => props.theme.colors.shadowGray };
    font-weight: 600;

    span {
      &:hover {
        font-weight: 600;
      }
      color: ${ props => props.theme.colors.default };
    }
  }

  @media screen and (max-width: 767px) {
    display: flex;
    background-color: #fff;
    border: none;
    overflow-x: scroll;
    gap: 15px;

    &::-webkit-scrollbar {
      display: none;
    }

    .clearAll {
      display: none;
    }
  }
`;

const ActiveFiltersComponent = ({ onClear, children }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  if (!children.length) return null;

  return (
    <StyledContainer theme={ theme }>
      { children }
      <Button
        className="clearAll"
        kind="ghost"
        onClick={ onClear }
        data-test="onClearAllFilters"
      >
        { t('filters.removeAll') }
        <span><X /></span>
      </Button>
    </StyledContainer>
  );
};

ActiveFiltersComponent.propTypes = {
  children: node,
  onClear: func,
};

export default ActiveFiltersComponent;
